import { render, staticRenderFns } from "./HomelyRemediesDetail.vue?vue&type=template&id=4dd8694a&scoped=true"
import script from "./HomelyRemediesDetail.vue?vue&type=script&lang=js"
export * from "./HomelyRemediesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8694a",
  null
  
)

export default component.exports